import React, { useEffect, useState } from "react";
import * as echarts from "echarts";

const StepLineChart = ({ data }) => {
  const [dataZoomEnabled, setDataZoomEnabled] = useState(false);
  const [dataZoomEnd, setDataZoomEnd] = useState();
  const [legend, setLegend] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width > 640) {
        setDataZoomEnabled(false);
        setDataZoomEnd(100);

        setLegend(true);
      } else {
        setDataZoomEnabled(true);
        setDataZoomEnd(20);
        setLegend(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const chartDom = document.getElementById("chart");
    const myChart = echarts.init(chartDom);

    const option = {
      title: {
        text: "Resolution Count",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        show: legend,
        orient: "horizontal",
        bottom: 0,
        left: "center",
      },
      grid: {
        left: "2%",
        right: "2%",
        bottom: "10%",
        containLabel: true,
      },

      xAxis: {
        type: "category",
        data: data.dates,
        splitLine: {
          show: false,
        },
      },
      yAxis: {
        type: "value",
        splitLine: {
          show: false,
        },
      },
      dataZoom: [
        {
          type: "slider",
          show: dataZoomEnabled,
          xAxisIndex: [0],
          filterMode: "filter",
          height: 10,
          backgroundColor: "#ccc",
          handleColor: "#2A5775",
          handleSize: 5,
          showDetail: false,
          fillerColor: "#2A5775",
          zoomOnMouseWheel: false,
          moveOnMouseMove: false,
          moveOnMouseWheel: false,
          zoomLock: true,
          start: 0,
          end: dataZoomEnd,
          bottom: 0,
          MarginTop: 10,
        },
        ,
      ],
      series: [
        {
          name: "Day Wise Opening Count",
          type: "line",
          smooth: true,
          data: data.openCounts,
          emphasis: {
            focus: "series",
          },
          itemStyle: {
            color: "#FF0000",
          },
        },
        {
          name: "Day Wise Closing Count",
          type: "line",
          smooth: true,
          emphasis: {
            focus: "series",
          },
          data: data.closeCounts,
          // itemStyle: {
          //   color: "#14C9C9",
          // },
        },
      ],
    };

    myChart.setOption(option);

    return () => {
      myChart.dispose();
    };
  }, [data]);

  return <div id="chart" style={{ width: "100%", height: 250 }}></div>;
};

export default StepLineChart;
